// import hooks
import { useDocument } from "../../hooks/useDocument";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useFirestore } from "../../hooks/useFirestore";
import { autenticazione } from "../../firebase/config";
import { useIsAdmin } from "../../hooks/useIsAdmin";
// import { filesCloud } from "../../firebase/config";

// import pacchetti
import { useParams } from "react-router-dom";
import { useState } from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";

// import styles
import "./Profile.css";

export default function Profile() {
  const { user } = useAuthContext();
  const { id } = useParams();
  const { document, error } = useDocument("users", id);
  const { updateDocument } = useFirestore("users");
  const admin = useIsAdmin(user);

  const [username, setUsername] = useState(user.displayName);
  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [verificaPassword, setVerificaPassword] = useState("");
  const [message, setMessage] = useState(null);
  const [newAdmin, setNewAdmin] = useState("");
  const [newResTecnico, setNewResTecnico] = useState("");
  // const [avatarError, setAvatarError] = useState(null);
  // const [avatar, setAvatar] = useState(null);

  const handleDisplayNameUpdate = (e) => {
    e.preventDefault();
    const currentUser = autenticazione.currentUser;
    currentUser
      .updateProfile({
        displayName: username,
      })
      .then(() => {
        updateDocument(id, {
          displayName: username,
        });
        setMessage("Nome utente modificato con successo");
      })
      .catch((err) => {
        setMessage("errore nell'aggiornamento del nome utente");
        console.log(err.message);
      });
  };

  const handlePasswordUpdate = (e) => {
    e.preventDefault();
    const currentUser = autenticazione.currentUser;
    const credentials = firebase.auth.EmailAuthProvider.credential(
      user.email,
      currentPassword
    );
    if (password === verificaPassword) {
      currentUser
        .reauthenticateWithCredential(credentials)
        .then(() => {
          currentUser
            .updatePassword(password)
            .then(() => {
              setMessage("Password modificata con successo");
            })
            .catch((err) => {
              setMessage("errore nell'aggiornamento della password");
              console.log(err.message);
            });
        })
        .catch((err) => {
          setMessage("Errore nell'aggiornamento della password");
          console.log(err.message);
        });
    } else {
      setMessage("Le due password non corrispondono");
    }
  };

  // Funzione di utilità per chiamare la funzione HTTP con supporto CORS
  const callSetUserRoleHttp = async (uid, role) => {
    try {
      // Ottieni il token di autenticazione dell'utente corrente
      const idToken = await user.getIdToken();

      // Effettua la chiamata HTTP con il token di autenticazione
      const response = await fetch(
        "https://us-central1-giuviprojects.cloudfunctions.net/setUserRoleHttp",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${idToken}`,
          },
          body: JSON.stringify({ uid, role }),
        }
      );

      // Verifica la risposta
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Errore nella richiesta");
      }

      return await response.json();
    } catch (error) {
      console.error("Errore nella chiamata HTTP:", error);
      throw error;
    }
  };

  const rendiAdmin = (e) => {
    e.preventDefault();
    const adminEmail = newAdmin;

    // Prima otteniamo l'UID dell'utente dalla sua email
    firebase
      .auth()
      .fetchSignInMethodsForEmail(adminEmail)
      .then(() => {
        // L'email esiste, ora otteniamo l'utente dal database
        return firebase
          .firestore()
          .collection("users")
          .where("email", "==", adminEmail)
          .get();
      })
      .then((querySnapshot) => {
        if (querySnapshot.empty) {
          throw new Error("Utente non trovato");
        }
        const userDoc = querySnapshot.docs[0];
        const uid = userDoc.id;

        // Ora chiamiamo la funzione HTTP con l'UID e il ruolo
        return callSetUserRoleHttp(uid, "admin");
      })
      .then((res) => {
        console.log(res);
        setMessage(`Ruolo admin assegnato a ${adminEmail}`);
      })
      .catch((err) => {
        console.error(err);
        setMessage(`Errore nell'assegnazione del ruolo admin: ${err.message}`);
      });
  };

  const rendiResTecnico = (e) => {
    e.preventDefault();
    const resTecnicoEmail = newResTecnico;

    // Prima otteniamo l'UID dell'utente dalla sua email
    firebase
      .auth()
      .fetchSignInMethodsForEmail(resTecnicoEmail)
      .then(() => {
        // L'email esiste, ora otteniamo l'utente dal database
        return firebase
          .firestore()
          .collection("users")
          .where("email", "==", resTecnicoEmail)
          .get();
      })
      .then((querySnapshot) => {
        if (querySnapshot.empty) {
          throw new Error("Utente non trovato");
        }
        const userDoc = querySnapshot.docs[0];
        const uid = userDoc.id;

        // Ora chiamiamo la funzione HTTP con l'UID e il ruolo
        return callSetUserRoleHttp(uid, "resTecnico");
      })
      .then((res) => {
        console.log(res);
        setMessage(`Ruolo Responsabile Tecnico assegnato a ${resTecnicoEmail}`);
      })
      .catch((err) => {
        console.error(err);
        setMessage(
          `Errore nell'assegnazione del ruolo Responsabile Tecnico: ${err.message}`
        );
      });
  };

  const handleAvatarChange = async (e) => {
    e.preventDefault();
    //   const uploadPath = `avatars/${user.uid}/${avatar.name}`;
    //   const image = await filesCloud.ref(uploadPath).put(avatar);
    //   const imageUrl = await image.ref.getDownloadURL();
    await user.updateProfile({
      photoURL:
        "https://firebasestorage.googleapis.com/v0/b/giuviprojects.appspot.com/o/avatars%2Fdefault%2Fgiuvi.png?alt=media&token=ccd38c20-cdcb-4766-83b9-d08686bc3fa2",
    });
    //   updateDocument(id, {
    //     photoURL: imageUrl,
    //   });
    console.log("avatar aggiornato");
  };

  return (
    <div className="profilo-box">
      {error && <p>{error}</p>}
      {document && <h2>Profilo di {document.displayName}</h2>}
      <img src={user.photoURL} alt="avatar" />
      <form onSubmit={handleDisplayNameUpdate} className="username-form">
        <label>
          <span>Modifica nome utente:</span>
          <input
            type="text"
            required
            onChange={(e) => setUsername(e.target.value)}
            value={username}
          />
        </label>
        <button className="btn">Invia</button>
      </form>
      <form onSubmit={handlePasswordUpdate} className="password-form">
        <label>
          <span>Password attuale:</span>
          <input
            type="password"
            required
            onChange={(e) => setCurrentPassword(e.target.value)}
            value={currentPassword}
          />
          <span>Nuova password:</span>
          <input
            type="password"
            required
            onChange={(e) => setPassword(e.target.value)}
            value={password}
          />
          <span>Conferma nuova password:</span>
          <input
            type="password"
            required
            onChange={(e) => setVerificaPassword(e.target.value)}
            value={verificaPassword}
          />
        </label>
        <button className="btn">Invia</button>
        {message && <p>{message}</p>}
      </form>
      {admin && (
        <>
          <form onSubmit={rendiAdmin} className="admin-form">
            <label>
              <span>Aggiungi nuovo Admin</span>
              <input
                type="text"
                placeholder="email nuovo admin"
                required
                onChange={(e) => setNewAdmin(e.target.value)}
                value={newAdmin}
              />
            </label>
            <button className="btn">Invia</button>
          </form>
          <form onSubmit={rendiResTecnico} className="admin-form">
            <label>
              <span>Aggiungi nuovo Responsabile Tecnico</span>
              <input
                type="text"
                placeholder="email nuovo responsabile tecnico"
                required
                onChange={(e) => setNewResTecnico(e.target.value)}
                value={newResTecnico}
              />
            </label>
            <button className="btn">Invia</button>
          </form>
          <form onSubmit={handleAvatarChange} className="avatar-form">
            <label>
              <span>Reset Avatar</span>
              {/**  
              <input required type="file" onChange={handleFileChange} />
              {avatarError && <div className="error">{avatarError}</div>}
              */}
            </label>
            <button className="btn">Invia</button>
          </form>
        </>
      )}
    </div>
  );
}
